module.exports = __webpack_public_path__ + "static/media/_space_red.d18a207f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/alphabet/_space_red.jpg
// module id = 47
// module chunks = 0